<p-dialog
  class="clsDialogCloseIconRemove"
  [visible]="showSwitchRoleModal"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  role="dialog"
  aria-label="Switch Role"
  [style]="{ width: '30vw' }"
  [resizable]="false">
  <ng-template pTemplate="header">
    <div class="d-flex align-items-center justify-content-between">
      <div role="alert">
        <p class="no-mar">Switch Role</p>
      </div>
      <button type="button" class="btn btn-link no-mar clsCloseBtn" (click)="onSwitchRoleClose()" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
          <path
            d="M38.57 29.0019L56.5131 11.0588C58.4956 9.07625 58.4956 5.86208 56.5131 3.88265L54.1211 1.49061C52.1379 -0.492534 48.9238 -0.492534 46.9443 1.49061L29.0019 19.4331L11.0588 1.48689C9.07625 -0.495631 5.86208 -0.495631 3.88265 1.48689L1.48689 3.87893C-0.495631 5.86208 -0.495631 9.07625 1.48689 11.0557L19.4331 29.0019L1.49061 46.9443C-0.492534 48.9275 -0.492534 52.1416 1.49061 54.1211L3.88265 56.5131C5.86518 58.4956 9.07934 58.4956 11.0588 56.5131L29.0019 38.57L46.9443 56.5131C48.9275 58.4956 52.1416 58.4956 54.1211 56.5131L56.5131 54.1211C58.4956 52.1379 58.4956 48.9238 56.5131 46.9443L38.57 29.0019Z" />
        </svg>
      </button>
    </div>
  </ng-template>
  <ng-container>
    <div class="profile-menu-item">
      <label class="d-block mb-2"> Role </label>

      <p-select
        [options]="switchRoleList"
        optionLabel="roleName"
        optionValue="roleCd"
        placeholder="Select Role"
        [(ngModel)]="selectedRole"
        appendTo="body"
        styleClass="w-100"
        (onChange)="onSwitchRoleChange($event.value)">
      </p-select>
    </div>
    <div class="mt-4">
      @if (isConfirm) {
        <strong [innerHTML]="roleChangeMsg"></strong>
      }
    </div>
  </ng-container>
  <ng-template pTemplate="footer">
    <div class="clearfix pt-3 text-right">
      <button class="btn btn-cancel ms-3" tabindex="-1" (click)="onSwitchRoleClose()">Cancel</button>
      <button class="btn btn-primary ms-3" tabindex="-1" [disabled]="!isSwitchRole" (click)="onConfirmSwitchRole()">
        Switch
      </button>
    </div>
  </ng-template>
</p-dialog>
